var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4725 6.16016H0V19.7109H4.4725V6.16016Z",
    fill: "#F8D210"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.655 6.31907C16.6075 6.30429 16.5625 6.28827 16.5125 6.27472C16.4525 6.26117 16.3925 6.25008 16.3312 6.24023C16.0937 6.19342 15.8338 6.16016 15.5288 6.16016C12.9213 6.16016 11.2675 8.02892 10.7225 8.75081V6.16016H6.25V19.7109H10.7225V12.3196C10.7225 12.3196 14.1025 7.6803 15.5288 11.0877C15.5288 14.1293 15.5288 19.7109 15.5288 19.7109H20V10.5666C20 8.51921 18.5763 6.81305 16.655 6.31907Z",
    fill: "#F8D210"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 4.31159C3.39562 4.31159 4.375 3.34641 4.375 2.1558C4.375 0.965183 3.39562 0 2.1875 0C0.979377 0 0 0.965183 0 2.1558C0 3.34641 0.979377 4.31159 2.1875 4.31159Z",
    fill: "#F8D210"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.dc4dec973238b0182020b12ae9f02fb6.svg";
export { ForwardRef as ReactComponent };